import { ShowItemSimilarService } from 'application/services/show-similar'
import { api } from 'infra/adapters/http-client-adapter'

export const handleShowItemSimilar = new ShowItemSimilarService(api)
